export const orders = [
 {
  id: 1,
  clients: 1001,
  adviser: 2001,
  quantity: 3,
  value: 2500000,
  status: 'In Progress',
  initialFeePercentage: 0.2,
  initialPay: 500000,
  initialFee: 200000,
  financingFee: 50000,
  deferinitial: 2,
  deferFinancing: 10,
  discounts: 50000,
  promise: 1,
  obs: 'Cliente interesado en propiedad X.',
  createAt: '2023-07-19 10:00:00',
  updateAt: '2023-07-19 12:30:00'
 },
 {
  id: 2,
  clients: 1002,
  adviser: 2002,
  quantity: 1,
  value: 750000,
  status: 'Completed',
  initialFeePercentage: 0.15,
  initialPay: 50000,
  initialFee: 100000,
  financingFee: 15000,
  deferinitial: 0,
  deferFinancing: 0,
  discounts: 0,
  promise: 0,
  obs: 'Propiedad Y entregada al cliente.',
  createAt: '2023-07-18 15:00:00',
  updateAt: '2023-07-20 09:45:00'
 },
 {
  id: 3,
  clients: 1003,
  adviser: 2003,
  quantity: 2,
  value: 1800000,
  status: 'In Progress',
  initialFeePercentage: 0.25,
  initialPay: 200000,
  initialFee: 100000,
  financingFee: 45000,
  deferinitial: 3,
  deferFinancing: 15,
  discounts: 30000,
  promise: 1,
  obs: 'Negociación en curso para propiedad Z.',
  createAt: '2023-07-17 12:00:00',
  updateAt: '2023-07-19 13:45:00'
 },
 {
  id: 4,
  clients: 1004,
  adviser: 2004,
  quantity: 4,
  value: 3200000,
  status: 'Pending', // Estado 'Pending'
  initialFeePercentage: 0.18,
  initialPay: 600000,
  initialFee: 180000,
  financingFee: 60000,
  deferinitial: 2,
  deferFinancing: 12,
  discounts: 20000,
  promise: 1,
  obs: 'Cliente interesado en propiedad A.',
  createAt: '2023-07-19 14:00:00',
  updateAt: '2023-07-19 16:30:00'
 },
 {
  id: 5,
  clients: 1005,
  adviser: 2005,
  quantity: 2,
  value: 1200000,
  status: 'Completed',
  initialFeePercentage: 0.12,
  initialPay: 300000,
  initialFee: 100000,
  financingFee: 30000,
  deferinitial: 1,
  deferFinancing: 6,
  discounts: 0,
  promise: 0,
  obs: 'Venta exitosa de propiedad B.',
  createAt: '2023-07-18 09:30:00',
  updateAt: '2023-07-20 11:15:00'
 },
 {
  id: 6,
  clients: 1006,
  adviser: 2006,
  quantity: 3,
  value: 2100000,
  status: 'In Progress',
  initialFeePercentage: 0.2,
  initialPay: 420000,
  initialFee: 150000,
  financingFee: 30000,
  deferinitial: 2,
  deferFinancing: 12,
  discounts: 30000,
  promise: 1,
  obs: 'Visita programada para propiedad C.',
  createAt: '2023-07-17 11:30:00',
  updateAt: '2023-07-20 14:45:00'
 },
 {
  id: 7,
  clients: 1007,
  adviser: 2007,
  quantity: 1,
  value: 650000,
  status: 'In Progress',
  initialFeePercentage: 0.2,
  initialPay: 100000,
  initialFee: 150000,
  financingFee: 20000,
  deferinitial: 1,
  deferFinancing: 6,
  discounts: 20000,
  promise: 1,
  obs: 'Cliente interesado en propiedad D.',
  createAt: '2023-07-20 14:00:00',
  updateAt: '2023-07-20 16:30:00'
 },
 {
  id: 8,
  clients: 1008,
  adviser: 2008,
  quantity: 2,
  value: 1200000,
  status: 'On Hold', // Estado 'On Hold'
  initialFeePercentage: 0.12,
  initialPay: 200000,
  initialFee: 100000,
  financingFee: 20000,
  deferinitial: 1,
  deferFinancing: 6,
  discounts: 10000,
  promise: 1,
  obs: 'Propiedad E en revisión.',
  createAt: '2023-07-21 09:00:00',
  updateAt: '2023-07-21 11:30:00'
 },
 {
  id: 9,
  clients: 1009,
  adviser: 2009,
  quantity: 2,
  value: 1800000,
  status: 'Pending', // Estado 'Pending'
  initialFeePercentage: 0.15,
  initialPay: 270000,
  initialFee: 120000,
  financingFee: 30000,
  deferinitial: 2,
  deferFinancing: 10,
  discounts: 15000,
  promise: 1,
  obs: 'Cliente interesado en propiedad F.',
  createAt: '2023-07-21 13:30:00',
  updateAt: '2023-07-21 15:45:00'
 },
 {
  id: 10,
  clients: 1010,
  adviser: 2010,
  quantity: 2,
  value: 1800000,
  status: 'Pending', // Estado 'Pending'
  initialFeePercentage: 0.15,
  initialPay: 270000,
  initialFee: 120000,
  financingFee: 30000,
  deferinitial: 2,
  deferFinancing: 10,
  discounts: 15000,
  promise: 1,
  obs: 'Cliente interesado en propiedad G.',
  createAt: '2023-07-22 09:30:00',
  updateAt: '2023-07-22 11:15:00'
 },
 {
  id: 11,
  clients: 1011,
  adviser: 2011,
  quantity: 1,
  value: 750000,
  status: 'On Hold', // Estado 'On Hold'
  initialFeePercentage: 0.12,
  initialPay: 100000,
  initialFee: 90000,
  financingFee: 15000,
  deferinitial: 1,
  deferFinancing: 6,
  discounts: 0,
  promise: 0,
  obs: 'Propiedad H en espera de aprobación.',
  createAt: '2023-07-22 15:00:00',
  updateAt: '2023-07-22 16:30:00'
 },
 {
  id: 12,
  clients: 1012,
  adviser: 2012,
  quantity: 3,
  value: 2100000,
  status: 'In Progress',
  initialFeePercentage: 0.2,
  initialPay: 420000,
  initialFee: 150000,
  financingFee: 30000,
  deferinitial: 2,
  deferFinancing: 12,
  discounts: 30000,
  promise: 1,
  obs: 'Visita programada para propiedad I.',
  createAt: '2023-07-23 11:30:00',
  updateAt: '2023-07-23 13:45:00'
 },
 {
  id: 13,
  clients: 1013,
  adviser: 2013,
  quantity: 2,
  value: 1200000,
  status: 'Pending', // Estado 'Pending'
  initialFeePercentage: 0.12,
  initialPay: 200000,
  initialFee: 100000,
  financingFee: 20000,
  deferinitial: 1,
  deferFinancing: 6,
  discounts: 10000,
  promise: 1,
  obs: 'Propiedad J en revisión.',
  createAt: '2023-07-23 14:00:00',
  updateAt: '2023-07-23 16:00:00'
 },
 {
  id: 14,
  clients: 1014,
  adviser: 2014,
  quantity: 1,
  value: 650000,
  status: 'On Hold', // Estado 'On Hold'
  initialFeePercentage: 0.2,
  initialPay: 100000,
  initialFee: 150000,
  financingFee: 20000,
  deferinitial: 1,
  deferFinancing: 6,
  discounts: 20000,
  promise: 1,
  obs: 'Cliente interesado en propiedad K.',
  createAt: '2023-07-24 14:00:00',
  updateAt: '2023-07-24 16:30:00'
 },
 {
  id: 15,
  clients: 1015,
  adviser: 2015,
  quantity: 2,
  value: 1800000,
  status: 'Pending', // Estado 'Pending'
  initialFeePercentage: 0.15,
  initialPay: 270000,
  initialFee: 120000,
  financingFee: 30000,
  deferinitial: 2,
  deferFinancing: 10,
  discounts: 15000,
  promise: 1,
  obs: 'Cliente interesado en propiedad L.',
  createAt: '2023-07-24 16:30:00',
  updateAt: '2023-07-25 09:15:00'
 },
 {
  id: 25,
  clients: 1025,
  adviser: 2025,
  quantity: 2,
  value: 1800000,
  status: 'Pending', // Estado 'Pending'
  initialFeePercentage: 0.15,
  initialPay: 270000,
  initialFee: 120000,
  financingFee: 30000,
  deferinitial: 2,
  deferFinancing: 10,
  discounts: 15000,
  promise: 1,
  obs: 'Cliente interesado en propiedad Y.',
  createAt: '2023-07-26 11:30:00',
  updateAt: '2023-07-26 13:45:00'
 },
 {
  id: 26,
  clients: 1026,
  adviser: 2026,
  quantity: 1,
  value: 750000,
  status: 'On Hold', // Estado 'On Hold'
  initialFeePercentage: 0.12,
  initialPay: 100000,
  initialFee: 90000,
  financingFee: 15000,
  deferinitial: 1,
  deferFinancing: 6,
  discounts: 0,
  promise: 0,
  obs: 'Propiedad Z en espera de aprobación.',
  createAt: '2023-07-26 15:00:00',
  updateAt: '2023-07-26 16:30:00'
 },
 {
  id: 27,
  clients: 1027,
  adviser: 2027,
  quantity: 3,
  value: 2100000,
  status: 'In Progress',
  initialFeePercentage: 0.2,
  initialPay: 420000,
  initialFee: 150000,
  financingFee: 30000,
  deferinitial: 2,
  deferFinancing: 12,
  discounts: 30000,
  promise: 1,
  obs: 'Visita programada para propiedad M.',
  createAt: '2023-07-27 09:30:00',
  updateAt: '2023-07-27 11:15:00'
 },
 {
  id: 28,
  clients: 1028,
  adviser: 2028,
  quantity: 2,
  value: 1200000,
  status: 'Pending', // Estado 'Pending'
  initialFeePercentage: 0.12,
  initialPay: 200000,
  initialFee: 100000,
  financingFee: 20000,
  deferinitial: 1,
  deferFinancing: 6,
  discounts: 10000,
  promise: 1,
  obs: 'Propiedad N en revisión.',
  createAt: '2023-07-27 12:00:00',
  updateAt: '2023-07-27 14:00:00'
 },
 {
  id: 29,
  clients: 1029,
  adviser: 2029,
  quantity: 1,
  value: 650000,
  status: 'On Hold', // Estado 'On Hold'
  initialFeePercentage: 0.2,
  initialPay: 100000,
  initialFee: 150000,
  financingFee: 20000,
  deferinitial: 1,
  deferFinancing: 6,
  discounts: 20000,
  promise: 1,
  obs: 'Cliente interesado en propiedad O.',
  createAt: '2023-07-28 14:00:00',
  updateAt: '2023-07-28 16:30:00'
 },
 {
  id: 30,
  clients: 1030,
  adviser: 2030,
  quantity: 2,
  value: 1800000,
  status: 'Pending', // Estado 'Pending'
  initialFeePercentage: 0.15,
  initialPay: 270000,
  initialFee: 120000,
  financingFee: 30000,
  deferinitial: 2,
  deferFinancing: 10,
  discounts: 15000,
  promise: 1,
  obs: 'Cliente interesado en propiedad P.',
  createAt: '2023-07-28 16:30:00',
  updateAt: '2023-07-29 09:15:00'
 }
];
